import 'moment/locale/nb';
import React from 'react';
import { ConfirmSwitchModal, ModalCancelButton, ModalDangerousActionButton } from './Components';
import { getActionName } from './util';
import { Label } from '../../components/Layout';

export const PromptConfirmReset = ({
  selectedAction,
  showPromptSwitchToCategoryResetProgress,
  showPromptSwitchToActionResetProgress,
  onCancel,
  onConfirm,
}) => (
  <ConfirmSwitchModal noEscape>
    {showPromptSwitchToCategoryResetProgress && (
      <Label marginBottom="2em" size="1.15em">
        Du kan bare
        {' '}
        {getActionName(selectedAction)}
        {' '}
        en dyreart om gangen. Dersom du ønsker å
        {' '}
        {getActionName(selectedAction)}
        {' '}
        flere dyrearter kan dette gjøres på separate innmeldinger.
      </Label>
    )}

    {showPromptSwitchToActionResetProgress && (
      <Label marginBottom="2em" size="1.15em">
        En innmelding kan kun inneholde enten dyr som du
        ønsker å melde inn til slakt, for kjøp, eller som
        du ønsker å selge. Hvis du ønsker å utføre både
        salg, kjøp og/eller innmelding kan dette gjøres på
        separate innmeldinger.
      </Label>
    )}

    <Label marginBottom="1em" size="1.15em">
      Ønsker du å bytte til en ny innmeldingstype og
      dermed forkaste registrert data på gjeldende
      innmeldingstype?
    </Label>

    <div
      name="buttonGroupConfirmModal"
      style={{
        display: 'flex',
        fontSize: '1.15em',
        justifyContent: 'center',
      }}
    >
      <ModalCancelButton onClick={onCancel}>
        Nei
      </ModalCancelButton>

      <ModalDangerousActionButton
        style={{ whiteSpace: 'normal' }}
        name="confirmModalConfirmButton"
        onClick={onConfirm}
      >
        Ja, forkast og start på ny innmeldingstype
      </ModalDangerousActionButton>
    </div>
  </ConfirmSwitchModal>
);
